<template>
  <div class="index">
    <el-carousel class="swiper index-swiper">
      <el-carousel-item class="swiper-item">
        <img class="swiper-item-img" src="../assets/ban3.png" alt="" />
      </el-carousel-item>
      <el-carousel-item class="swiper-item">
        <img class="swiper-item-img" src="../assets/ban2.png" alt="" />
      </el-carousel-item>
    </el-carousel>
    <div class="index-con">
      <div class="message">
        <div class="title">
          2024食品交叉科学国际期刊前沿论坛（食品生物科学&食品营养）<br />暨第十六届国际功能食品学会年会
        </div>
        <div class="small-title">
          (FIFS & ISNFF 2024)
          <br /><br />
          大会主题：Food4Future
        </div>
        <div class="text" style="text-align: center">
          2024年12月3-6日 中国•无锡
        </div>
        <div class="line"></div>
        <div class="text">
          <p class="em-2">
            世界人口增长和资源过度开发导致食物资源短缺和潜在的粮食安全问题。此外，不良的生活方式和饮食习惯导致全球范围内慢性病不断上升，成为重要的公共卫生挑战。食品交叉科学（如食品生物科学、食品营养学等）的综合应用为缓解全球粮食安全问题和饥荒困境，以及解决全球公共健康问题提供了可行的解决途径。
          </p>
          <p class="em-2">
            为促进食品交叉科学、营养保健品和功能食品领域的学术交流与技术创新，江南大学、爱思唯尔出版集团和国际功能食品学会（ISNFF）共同发起主办<b>2024食品交叉科学国际期刊前沿论坛（食品生物科学&食品营养）暨第十六届国际功能食品学会年会。</b>
            本次会议由江南大学食品学院、江南大学食品学术期刊中心和江苏省食品科学与技术学会承办，将于2024年12月3-6日在江苏省无锡市君来世尊酒店召开。
          </p>
          <p class="em-2">
            会议旨在聚焦当前食品交叉科学、营养保健品和功能食品领域的热点问题，邀请全球知名专家学者及行业代表，共同交流食品交叉科学领域的顶尖研究成果，并就这些领域的发展前景和创新机遇展开深入研讨。ISNFF会议将涉及食品生物活性成分（蛋白质和肽类、油脂、碳水化合物和多酚）及其代谢物和健康效应，以及其他相关主题。
          </p>
          <!--div class="swiper-item-img2">
            <img :src="'https://static.ais.cn/resource/editor/2024/03/370240319164225525.png'" alt="" />
          </!--div-->


          <div class="title-big">
            <a href="https://www.fifs-isnff-2024.cn/public/uploads/会议通知-盖章扫描版.pdf" target="_blank">
              <br>
              <font color=red>点击下载会议通知</font>
            </a>
          </div>

          <p class="two-title">
            <img class="small-img" src="https://fhk.ais.cn/cms/website/editor/202205/383220513161953213.png" alt="" />
            <b>一、会议主题：</b>
          </p>
          <p>1. 食品的生化、生物物理和生物特性</p>
          <p>2. 食品生产和加工中的遗传、细胞和分子生物学</p>
          <p>3. 用于食品相关系统的生物材料</p>
          <p>4. 新技术在食品中的应用</p>
          <p>5. 食品功能因子挖掘与作用机制解析</p>
          <p>6. 特定（殊）人群的食品营养</p>
          <p>7. 食品组分与肠道微生物互作</p>
          <p>8. 食品与机体免疫和代谢</p>
          <p>9. 主要食品生物活性成分（蛋白质和肽类、油脂、碳水化合物）</p>
          <p>10. 多酚、类胡萝卜素及其代谢物和健康效应</p>
          <p>11. 微生物组、益生元和益生菌及其健康影响</p>
          <p>12. 功能成分的控制释放和递送</p>
          <p>13. 食品生物活性成分的生物可及性和生物利用率</p>
          <p>14. 肥胖、糖尿病和代谢综合征</p>
          <p>15. 食品加工废弃物的升级回收</p>
          <p>16. 人工智能及其他主题</p>
        </div>
      </div>
    </div>
    <div class="index-con message">
      <div class="people">
        <div class="people-title bg-green">
          <i class="el-icon-user"></i>
          二、演讲嘉宾：（持续更新）
        </div>
        <div class="title-big">
          Plenary Speakers
        </div>
        <el-carousel class="people-lists-contents" :loop="true" :autoplay="true" indicator-position="outside">
          <el-carousel-item class="people-lists">
            <!-- <div class="people-lists"> -->
            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/user001.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Paul Ross</b>
              </div>
              <div class="people-text">University College Cork</div>
              <div class="people-text text-999">Ireland</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Bradley.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Bradley Bolling</b>
              </div>
              <div class="people-text">University of Wisconsin-Madison</div>
              <div class="people-text text-999">USA</div>
            </div>


            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Chi-Tang.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Chi-Tang Ho</b>
              </div>
              <div class="people-text">Rutgers University</div>
              <div class="people-text text-999">USA</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Kazuo.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Kazuo Miyashita</b>
              </div>
              <div class="people-text">Hokkaido Bunkyo University</div>
              <div class="people-text text-999">Japan</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Ronald.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Ronald Pegg</b>
              </div>
              <div class="people-text">University of Georgia</div>
              <div class="people-text text-999">Canada</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Fereidoon.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Fereidoon Shahidi</b>
              </div>
              <div class="people-text">Memorial University</div>
              <div class="people-text text-999">Canada</div>
            </div>

            <div class="people-list">
              <div class="people-pic">
                <img src="../assets/Jerzy.jpg" alt="" />
              </div>
              <div class="peoples-title">
                <b>Jerzy Zawistowski</b>
              </div>
              <div class="people-text">University of British Columbia</div>
              <div class="people-text text-999">Canada</div>
            </div>

          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="index-con">
        <div class="people">
          <div class="title-big">
            Keynote Speakers
          </div>
          <el-carousel class="people-lists-contents" :loop="true" :autoplay="true">
            <el-carousel-item class="people-lists">
              <!-- <div class="people-lists"> -->
              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Cesarettin.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Cesarettin Alasalvar</b>
                </div>
                <div class="people-text">Food Institute of TÜBİTAK MRC</div>
                <div class="people-text text-999">Turkiye</div>
              </div>

              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Rotimi.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Rotimi Aluko</b>
                </div>
                <div class="people-text">University of Manitoba</div>
                <div class="people-text text-999">Canada</div>
              </div>

              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Carlos.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Carlos L. Cespedes-Acuña</b>
                </div>
                <div class="people-text">University of Bio Bio</div>
                <div class="people-text text-999">Chile</div>
              </div>

              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Ying.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Ying Li</b>
                </div>
                <div class="people-text">Jiangsu Academy of Agricultural Sciences</div>
                <div class="people-text text-999">China</div>
              </div>
              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Katia.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Katia Liburdi</b>
                </div>
                <div class="people-text">University of Tuscia</div>
                <div class="people-text text-999">Viterbo, Italy</div>
              </div>


              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/John.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>John Muyonga</b>
                </div>
                <div class="people-text">Makerere University</div>
                <div class="people-text text-999">Uganda</div>
              </div>

            </el-carousel-item>

            <el-carousel-item class="people-lists">
              <!-- <div class="people-lists"> -->

              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Hyun.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Hyun Jin Park</b>
                </div>
                <div class="people-text">Korea University</div>
                <div class="people-text text-999">South Korea</div>
              </div>

              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Tatiana.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Tatiana Pimentel </b>
                </div>
                <div class="people-text">Federal Institute of Parana</div>
                <div class="people-text text-999">Brazil</div>
              </div>

              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Kenji.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Kenji Sato</b>
                </div>
                <div class="people-text">Kyoto University</div>
                <div class="people-text text-999">Japan</div>
              </div>


              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Giuseppe.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Giuseppe Spano</b>
                </div>
                <div class="people-text">University of Foggia</div>
                <div class="people-text text-999">Italy</div>
              </div>


              <div class="people-list">
                <div class="people-pic">
                  <img src="../assets/Youling.jpg" alt="" />
                </div>
                <div class="peoples-title">
                  <b>Youling L Xiong</b>
                </div>
                <div class="people-text">University of Kentucky</div>
                <div class="people-text text-999">USA</div>
              </div>

            </el-carousel-item>


          </el-carousel>
        </div>
      </div>
      <div class="text">
        <p class="two-title">
          <img class="small-img" src="https://fhk.ais.cn/cms/website/editor/202205/383220513161953213.png" alt="" />
          <b>三、摘要投稿：</b>
        </p>
        <p>
          会议设有口头报告和海报展示环节，欢迎各位感兴趣的老师和研究生在线提交摘要。名额有限，欲报从速。
        </p>
        <p>
          摘要请用英文撰写，篇幅不超过250个单词。请由主要汇报人提交，勿重复提交。摘要申请截止日期为2024年10月30日。摘要中选通知邮件将于2024年11月15日前发送至申请人的注册邮箱。
        </p>
        <br />
        <br />
        <div class="theme-img">
          <img src="https://static.ais.cn/resource/editor/2023/07/356230718102919848.gif" alt="" />
        </div>

        <p class="two-title">
          <img class="small-img" src="https://fhk.ais.cn/cms/website/editor/202205/383220513161953213.png" alt="" />
          <b>四、奖项：</b>
        </p>
        <p style="line-height: 1.9">
          学生竞赛奖（口头报告奖、海报展示奖） <br />
          爱思唯尔青年科学家奖<br />
          ISNFF青年科学家奖<br />
          Fereidoon SHAHIDI奖<br />
          ISNFF院士奖<br />
          终身成就奖<br />
          优异奖<br />
          （各奖项详情请
          <a href="https://www.foodbio-foodnutri.com/index/index.html#/Awards" target="blank">点击此处</a>
          查询）
        </p>
        <p class="two-title">
          <img class="small-img" src="https://fhk.ais.cn/cms/website/editor/202205/383220513161953213.png" alt="" />
          <b>五、会议报名：</b>
        </p>
        <p>
          需提交摘要的参会者，请在会议网站<span class="text-blue" style="margin-right: 10px" @click="toReg">
            注册
          </span>
          <span class="text-blue" @click="toLogin"> 登录 </span>，填写参会者信息后，提交摘要。仅参会者，可直接在手机端（二维码如下）注册报名。
        </p>
        <br />
        <p>
          <span>（一）会议费： </span>
        </p>
        <div class="table">
          <div class="list">
            <div class="list-left">国内</div>
            <div class="list-right">
              <div class="p">在职人员：2300元/人</div>
              <div class="p no-border">普通在校研究生：1200元/人</div>
            </div>
          </div>
          <div class="list no-border">
            <div class="list-left">国外</div>
            <div class="list-right">
              <div class="p">在职人员：495美元/人</div>
              <div class="p no-border">普通在校研究生：225美元/人</div>
            </div>
          </div>
        </div>

        <p>
          <span>（二）缴费方式： </span>
        </p>
        <p style="text-indent: 2em;">1. 手机端支付（内含开票信息和房间预订）</p>
        <img style="margin-left: 2em;" width="150" src="../assets/pic-1.png" alt="" />
        <p style="text-indent: 2em;">2. 现场支付</p>

        <p>
          <span>（三）住宿费： </span>
        </p>
        <p>
          每个房间450元一晚 <br />
          大床房提供一份早餐，标准间提供两份早餐。
        </p>
        <p>
          <span>（四）会议QQ群： </span>
        </p>

        <div class="text">
          参会代表可申请加入本次会议QQ群（群号为472592182，二维码如下），以便及时接收会议最新通知。
          <p><img width="200" src="../assets/qq.png" alt="" /></p>
        </div>

        <p class="two-title">
          <img class="small-img" src="https://fhk.ais.cn/cms/website/editor/202205/383220513161953213.png" alt="" />
          <b> 六、会议重要日期：</b>
          <img class="right-img" src="https://static.ais.cn/resource/editor/2024/03/370240319162652388.gif" alt="" />
        </p>
        <p>
          摘要提交截止日：
          <b>2024.10.30</b>
          <img class="small-img" src="http://file.keoaeic.org/upload_path/kindeditor/201801/1-1F5311H64K35.gif"
            alt="" />
        </p>
        <p>
          作者通知截止日：
          <b>2024.11.15</b>
          <img class="small-img" src="http://file.keoaeic.org/upload_path/kindeditor/201801/1-1F5311H64K35.gif"
            alt="" />
        </p>
        <br /><br />
        <!-- <p class="two-title">
          <img
            class="small-img"
            src="https://fhk.ais.cn/cms/website/editor/202205/383220513161953213.png"
            alt=""
          />
          <b> 七、缴费方式：</b>
        </p>
        <p>
          1.
          <a
            class="text-url text-blue"
            target="_blank"
            href="https://www.fifs-isnff-2024.cn/index/index.html#/here"
          >
            线上支付
          </a>
        </p>
        <p>2. 现场支付</p> -->
        <p class="two-title">
          <img class="small-img" src="https://fhk.ais.cn/cms/website/editor/202205/383220513161953213.png" alt="" />
          <b>七、联系我们：</b>
        </p>
        <p>电话：0510-85197031</p>
        <p>电子邮箱：fifs@jiangnan.edu.cn</p>
        <br />
        <p class="two-title">
          <img class="small-img" src="https://fhk.ais.cn/cms/website/editor/202205/383220513161953213.png" alt="" />
          <b> 八、酒店链接 </b>
        </p>
        <p>
          <a href="https://www.worldhotelgrandjuna.cn/" target="_blank">
            <span class="text-blue">无锡君来世尊酒店</span>
          </a>
        </p>

        <p><b>住宿费：</b></p>
        <p>每个房间450元一晚</p>
        <p style="margin-bottom: 100px">
          大床房提供一份早餐，标准间提供两份早餐。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  onload() { },
  mounted() { },
  onShow() { },
  methods: {
    toReg() {
      this.$router.push("/registerzh");
    },
    toLogin() {
      this.$router.push("/loginzh");
    },
  },
};
</script>

<style scoped lang="less">
.small-img {
  height: 17px;
  width: auto;
}

.theme-img img {
  height: 25px;
}

.two-title {
  display: flex;
  align-items: center;
  color: #333;
  position: relative;

  img {
    margin-right: 5px;
  }

  .right-img {
    position: absolute;
    left: 400px;
    height: 250px;
    top: 0;
  }
}

.title-big {
  color: #595959;
  font-size: 20px;
  font-weight: 600;

  align-items: center;
  margin-bottom: 14px;
  margin-top: 14px;
  text-align: center;
}

.title-down {
  color: red;
  font-size: 22px;
  font-weight: 600;


  margin-bottom: 14px;
  margin-top: 14px;
  text-align: center;
}

.table {
  width: 800px;
  margin: 30px auto;
  border: 1px solid #28d6ec;

  .list {
    height: 80px;
    display: flex;
    box-sizing: border-box;
    border-bottom: 1px solid #28d6ec;
  }

  .list-left {
    width: 80px;
    border-right: 1px solid #28d6ec;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
  }

  .list-right {
    flex: 1;
  }

  .p {
    flex: 1;
    height: 40px;
    border-bottom: 1px solid #28d6ec;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .no-border {
    border: 0;
  }
}

.em-2 {
  text-indent: 2em;
}

.contact-us {
  margin-top: 20px;
  color: #fff;
  padding-top: 20px;
  text-align: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  background: #28d6ec;

  .contact-title {
    font-size: 26px;
    font-weight: 600;
    color: #fff;
    text-align: center;
  }

  .contact-con {
    width: auto;
    display: inline-block;
    margin: 0 auto;
    text-align: center;
  }

  .contact-text {
    text-align: center;
    margin: 10px auto;
  }

  .em-web {
    margin: 10px auto;
    justify-content: space-between;
    align-items: center;
    display: flex;
  }

  .em-web p {
    margin-bottom: 6px;
  }

  .em-web p:nth-of-type(1) {
    margin-right: 20px;
  }

  .mt-20 {
    margin-top: 50px;
  }
}

.people {
  margin-top: 15px;

  .people-title {
    background: #28d6ec;
    color: #fff;
    height: 40px;
    font-size: 16px;
    font-weight: 600;
    align-items: center;
    display: flex;
    padding-left: 15px;
  }

  .people-title i {
    margin-right: 8px;
    font-size: 18px;
  }

  .people-lists {
    display: flex;
    padding: 15px 10px 25px;
    box-sizing: border-box;
  }

  .h-350 {
    height: 350px;
  }

  .people-list {
    width: calc(20% - 10px);
    margin-right: 5px;
  }

  .people-pic {
    width: 110px;
    height: 150px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid #ccc;
    //background: #ddd;
    margin: 0 auto;
    border-radius: 4px;
  }

  .people-pic img {
    width: auto;
    height: 100%;
  }

  .people-title {
    font-weight: 600;
    text-align: center;
  }

  .peoples-title {
    text-align: center;
    padding-top: 6px;
    font-size: 12px;
  }

  .people-text {
    box-sizing: border-box;
    text-align: center;
    color: #666;
  }
}

.dates {
  background: #28d6ec;
  color: #fff;
  margin-top: 50px;
  padding-top: 50px;

  .title {
    font-size: 30px;
    text-align: center;
    font-weight: 600;
  }

  .lists {
    display: flex;
    align-items: center;
    margin-top: 30px;
    padding-bottom: 50px;
  }

  .list {
    border-right: 1px solid #fff;
    text-align: center;
    flex: 1;
    padding: 10px 0;
  }

  .list:nth-last-of-type(1) {
    border-right: 0;
  }

  .list p:nth-of-type(1) {
    margin-bottom: 18px;
  }
}

.text-blue {
  color: #28d6ec;
  cursor: pointer;
  text-decoration: underline;
}

.type-lists {
  display: flex;
  flex-wrap: wrap;
  color: #595959;
  padding-bottom: 50px;

  .pics {
    width: 60%;
    display: flex;

    .pic {
      width: auto;
      height: 66px;
    }
  }

  .w-718 {
    width: 718px;
  }

  .type-list {
    width: calc(50% - 15px);
    margin-top: 30px;
  }

  .type-list:nth-of-type(2n) {
    margin-left: 30px;
  }

  .title {
    color: #28d6ec;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    font-family: "Microsoft YaHei", "宋体", serif;
  }

  .text {
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
    font-family: "Microsoft YaHei", "宋体", serif;
  }

  .btn span {
    cursor: pointer;
    background: #28d6ec;
    text-shadow: 0.2px 0.2px 1px rgba(0, 0, 0, 0.5);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);
    padding: 10px 20px;
    border-radius: 50px;
    display: inline-block;
    color: white;
    margin-bottom: 16px;
  }

  .text-blue {
    color: #28d6ec;
    cursor: pointer;
    text-decoration: underline;
  }

  .pic {
    width: 60%;
    height: auto;
  }

  .gif {
    width: auto;
    height: 14px;
  }

  .square {
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-left: 15px solid #28d6ec;
  }

  .flex-1 {
    width: 100%;
  }
}

.message {
  .title {
    color: #28d6ec;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    margin-top: 60px;
    margin-bottom: 24px;
    font-family: "Microsoft YaHei", "宋体", serif;
  }

  .small-title {
    font-size: 20px;
    color: #595959;
    text-align: center;
    margin-bottom: 24px;
  }

  .line {
    width: 290px;
    margin: 10px auto 30px;
    height: 1px;
    margin-bottom: 24px;
    background: #7f7f7f;
  }

  .text {
    font-size: 16px;
    color: #7f7f7f;
    line-height: 24px;
    padding-bottom: 40px;
    font-family: "Microsoft YaHei", "宋体", serif;

    p {
      margin-top: 10px;
    }
  }
}

.index-con {
  max-width: 1200px;
  margin: 0 auto;
}

.swiper {
  max-width: 1200px;
  margin: 0 auto;
}

.swiper-item {
  height: 300px;

  .swiper-item {
    display: flex;
    align-items: center;
    background: linear-gradient(to bottom, #8cd1f9, #248bbc);
    justify-content: center;
  }

  .swiper-item-img {
    width: 100%;
    height: auto;
  }
}

.swiper-item-img2 {
  text-align: center;
}

.swiper-item-img2 img {
  width: 800px;
  height: 230px;
}

.index {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .swiper {
    height: 190px;
    min-height: 150px;
    overflow: hidden;

    .swiper-item {
      align-items: start;
    }
  }

  .el-carousel__container {
    height: 190px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sponsors.vue